import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { colors, borderRadius, SPACE_COZY } from '@/styles';

export const summaryBarStyles = css`
  display: inline-flex;
  min-height: 48px;
  padding: 0 ${SPACE_COZY}px;
  & > div:first-of-type {
    min-width: 300px; // avoid shifting when switching draft status
  }
`;

export const badgeStyles = css`
  font-size: 11px;
  font-weight: 600;
`;

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
export const generalBarStyles = css`
  ${borderRadius};
  background-color: ${token('color.background.input.hovered', colors.N10A)};
  label:focus-within {
    border-color: rgba(0, 0, 0, 0); // need this placeholder to occupy space
  }
`;
